/**
 * Premade ElevenLabs voice IDs (v1 text-to-speech). Used for manual assignment + preview webhook.
 */
export type MockElevenVoice = {
  voice_id: string;
  voice_name: string;
};

export const MOCK_ELEVEN_VOICES: MockElevenVoice[] = [
  { voice_id: "21m00Tcm4TlvDq8ikWAM", voice_name: "Rachel (warm narrator)" },
  { voice_id: "AZnzlk1XvdvUeBnXmlld", voice_name: "Domi (confident)" },
  { voice_id: "EXAVITQu4vr4xnSDxMaL", voice_name: "Bella (soft)" },
  { voice_id: "ErXwobaYiN019PkySvjV", voice_name: "Antoni (clear)" },
  { voice_id: "MF3mGyEYCl7XYWbV9V6O", voice_name: "Elli (expressive)" },
  { voice_id: "TxGEqnHWrfWFTfGW9XjX", voice_name: "Josh (steady)" },
  { voice_id: "VR6AewLTigWG4xSOukaG", voice_name: "Arnold (crisp)" },
  { voice_id: "SOYHLrjzK2X1ezoPC6Id", voice_name: "Sam (authoritative)" },
];

export const DEFAULT_VOICE_SETTINGS = {
  stability: 0.4,
  similarity_boost: 0.75,
  style: 0.6,
  use_speaker_boost: true,
} as const;
